<template>
    <v-container fluid>         
        <v-row v-show="!loading">
            <v-col cols="12">
            <v-expansion-panels accordion multiple focusable hover v-model="panel">
                <v-expansion-panel>
                    <v-expansion-panel-header>Przebieg wizyty / badania / procedury medyczne</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12">
                            <VisitProcedures :items.sync="visitProcedures" :visitid="visitid"></VisitProcedures>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <p>Dodatkowy opis:</p>
                            <tiptap-vuetify v-model="visitProcess" name="process" 
                                           :readonly="!allowedit"
                                           :extensions="extensions"
                                           :toolbar-attributes="{ color: 'primary' }"
                                           placeholder="Dodatkowy opis przebiegu..." />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header>Rozpoznanie</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12">
                            <VisitConditions :items.sync="visitConditions" :visitid="visitid"></VisitConditions>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <p>Dodatkowy opis:</p>
                            <tiptap-vuetify v-model="visitRecognition" name="recognition" 
                                           :readonly="!allowedit"
                                           :extensions="extensions"
                                           :toolbar-attributes="{ color: 'primary' }"
                                           placeholder="Dodatkowy opis rozpoznania..." />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header>Zalecenia</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <tiptap-vuetify v-model="visitRecommendations" name="recommendations" 
                                       :readonly="!allowedit"
                                       :extensions="extensions"
                                       :toolbar-attributes="{ color: 'primary' }"
                                       placeholder="Zalecenia..." />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            </v-col>
            <v-col cols="12" v-if="allowedit">
                <v-spacer></v-spacer>
                 <v-btn @click="saveVisitProcess" color="success" v-show="!loading">Zapisz przebieg wizyty</v-btn>
            </v-col>
        </v-row>
        <v-progress-linear :indeterminate="true" v-show="loading"></v-progress-linear>
    </v-container>
</template>

<script>
import { visitService } from "@/services/";
import VisitProcedures from "@/components/visits/VisitProcedures";
import VisitConditions from "@/components/visits/VisitConditions";
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Blockquote, HardBreak, History } from 'tiptap-vuetify'
import swal from "sweetalert"

export default {
  name: "VisitProcess",
  components: {VisitConditions, VisitProcedures, TiptapVuetify},
  data() {
    return {
      loading: false,
      panel: [...Array(3).keys()].map((k, i) => i),
      extensions: [
        History,
        Blockquote,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        Code,
        Paragraph,
        HardBreak
      ]
      //$emit('input', this.recommendations)
    }
  },
  computed: {
      visitRecognition: {
          get: function() {
              return this.recognition
          },
          set: function(val) {
              this.$emit('update:recognition',val)
          }
      },
      visitProcess: {
          get: function() {
              return this.process
          },
          set: function(val) {
              this.$emit('update:process',val)
          }
      },
      visitRecommendations: {
          get: function() {
              return this.recommendations
          },
          set: function(val) {
              this.$emit('update:recommendations',val)
          }
      },
    visitProcedures: {
        get: function() {
          return this.procedures ? this.procedures : []
        },
        set: function(val) {
          this.$emit('update:procedures',val)
        }
    },
    visitConditions: {
      get: function() {
        return this.conditions ? this.conditions : []
      },
      set: function(val) {
        this.$emit('update:conditions',val)
      }
    }
  },
  props: {
    recognition: String,
    recommendations: String,
    process: String,
    visitid: Number,
    allowedit: Boolean,
    procedures: Array,
    conditions: Array
  },
  methods: {
      saveVisitProcess() {
          this.loading = true;
          visitService.UpdateVisitProcess({id: this.visitid, recognition: this.visitRecognition, recommendations: this.visitRecommendations, process: this.process }).then(() => {

              this.loading = false
          }).catch(() => {
              this.showError("Błąd zapisu przebiegu wizyty")
              this.loading = false
          })
      },
    showError(close, text) {
        swal({
            title: "Błąd",
            text: text,
            icon: "warning",
            button: "OK"
        }).then(() => {
            this.loading = false;            
        });
    }      
  }
}
</script>

<style>

</style>
